import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { isPlanBasic } from "@circle-react/helpers/planHelpers";
import { affiliateRoutes } from "@circle-react/lib/routes/affiliates";

import { t } from "@/i18n-js/instance";

import { NavGroup } from "../NavGroup";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

export const usePaywallsAffiliatesLinks = (): Link[] => {
  const { currentCommunity } = usePunditUserContext();
  const isBasicPlan = isPlanBasic(currentCommunity?.current_plan_tier);

  return [
    {
      label: t("settings_nav_v3.paywalls_affiliates.directory"),
      path: affiliateRoutes.list(),
      exact: true,
    },
    {
      label: t("settings_nav_v3.paywalls_affiliates.commissions"),
      path: affiliateRoutes.commissions(),
      exact: true,
    },
    {
      label: t("settings_nav_v3.paywalls_affiliates.settings"),
      path: affiliateRoutes.settings(),
      exact: true,
      isDisabled: isBasicPlan,
    },
  ];
};

export const PaywallsAffiliatesLinks = () => {
  const links = usePaywallsAffiliatesLinks();

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content title={t("settings_nav_v3.paywalls_affiliates.label")}>
        {links.map(link => (
          <SubNavLinkItem key={link.path} label={link.label} to={link.path} />
        ))}
      </NavGroup.Content>
    </NavGroup>
  );
};
